<script context="module" lang="ts">
  export let activeElementShouldShow = false;
  export function hideActiveElementToolbar() {
    if (!container) return;
    container.style.display = 'none';
  }

  function getAbsolutePosition(element: Element | HTMLElement) {
    const rect = element.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    return {
      top: rect.top + scrollTop,
      left: rect.left + scrollLeft
    };
  }

  export function showActiveElementToolbar() {
    console.log('Showing active element toolbar', parent);
    if (!container || !activeElementShouldShow) return;
    container.style.display = 'inline-flex';
    const position = getPosition(parent);
    const canvasPosition = getCanvasPosition();
    console.log('Position', position);
    const containerPosition = getPosition(container);
    console.log('Container position', containerPosition);
    const containerArea = document.querySelector('#containerArea');
    if (!containerArea) return;
    let topPosition = position.top - 30;
    if (canvasPosition && topPosition < canvasPosition.top) topPosition = canvasPosition.top - 30;
    const horizontalOffset = position.width / 2 - containerPosition.width / 2;
    const leftPosition = position.left + horizontalOffset;
    container.style.left = leftPosition + 'px';
    container.style.top = topPosition + 'px';
    return container;
  }

  const getPosition = (element: Element | HTMLElement): DOMRect => {
    const rect = element.getBoundingClientRect();
    return rect;
  };

  const getCanvasPosition = (): DOMRect | undefined => {
    const rect = document.getElementById('finalImageToExport')?.getBoundingClientRect();
    return rect;
  };

  export let container: HTMLElement;
  let parent: Element;
</script>

<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import editorStore from '../editor.store';
  import type {EditorModule} from '../editor.types';
  import {getEditorModules} from '../modules';
  import type {ToolbarAction} from '../Toolbar/ToolbarModule';
  import ToolItem from '../Toolbar/ToolItem.svelte';
  import type {EditorActiveComponent} from '../types';
  import Element from '../ElementsView/Element.svelte';
  let modules: EditorModule[];
  let active: EditorActiveComponent = null;
  let actions: Array<ToolbarAction>;

  const unmount = editorStore.subscribe(store => {
    if (active == store.activeComponent) return;
    hideActiveElementToolbar();
    // if (actions && actions.length) return showActiveElementToolbar();
    // else {
    //   return hideActiveElementToolbar();
    // }
    activeElementShouldShow = false;
    active = store.activeComponent;
    if (container) container.style.display = 'none';
    if (container && store.activeComponent) {
      // store.activeComponent.appendChild(container);
      parent = store.activeComponent;
      modules = store.activeComponent ? getEditorModules(parent) : [];
      console.log('modules', modules);
      actions = modules.reduce<ToolbarAction[]>((acc, module) => {
        if (!module.elementToolbar || module.elementToolbar.length == 0) return acc;
        return [...acc, ...module.elementToolbar];
      }, []);
      if (actions.length) {
        activeElementShouldShow = true;
        return showActiveElementToolbar();
      }
    }
  });

  onMount(() => {
    hideActiveElementToolbar();
  });

  onDestroy(unmount);
</script>

<div id="element-toolbar" class="shadow-md" bind:this={container}>
  {#if actions && actions.length}
    <div class="relative inline-flex items-center space-x-2">
      {#each actions as item}
        <div class="flex space-x-2">
          <ToolItem {item} />
        </div>
      {/each}
    </div>
  {/if}
</div>

<style lang="postcss">
  #element-toolbar {
    @apply items-end justify-end rounded-xl bg-white p-1 px-3 text-white shadow-md;
    position: fixed;
    display: inline-flex;
    flex-wrap: wrap;
    z-index: 10000;
    top: -10000;
  }
  .gg-trash {
    --ggs: 0.8;
  }
</style>
